var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultEventBanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 429,
    viewBox: "0 0 343 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_159590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 325,
    height: 384,
    fill: "#F7F0F0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.108,
    y: 138.803,
    width: 138.617,
    height: 133.228,
    rx: 18.5185,
    fill: "#F7F0F0",
    stroke: "white",
    strokeWidth: 1.48148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.555,
    y: 145.25,
    width: 124.831,
    height: 134.71,
    rx: 8.88889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2407,
    y: 138.803,
    width: 138.617,
    height: 133.228,
    rx: 18.5185,
    fill: "#F7F0F0",
    stroke: "white",
    strokeWidth: 1.48148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6875,
    y: 145.25,
    width: 124.831,
    height: 134.71,
    rx: 8.88889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.772,
    y: 121.741,
    width: 138.617,
    height: 133.228,
    rx: 18.5185,
    fill: "#F7F0F0",
    stroke: "white",
    strokeWidth: 1.48148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.219,
    y: 128.188,
    width: 124.831,
    height: 134.71,
    rx: 8.88889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3125,
    y: 175.812,
    width: 250.37,
    height: 105.185,
    fill: "url(#paint0_linear_24424_159590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_159590",
    x: -15.9133,
    y: -6.91333,
    width: 376.827,
    height: 435.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.9567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94 0 0 0 0 0.914933 0 0 0 0 0.914933 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_159590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_159590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24424_159590",
    x1: 171.498,
    y1: 199.498,
    x2: 171.498,
    y2: 280.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F0F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680687,
    stopColor: "#F7F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultEventBanner);
export default __webpack_public_path__ + "static/media/default-event-banner.e303f30dd2b368f2e5b20b8f13e5e92e.svg";
export { ForwardRef as ReactComponent };